// extracted by mini-css-extract-plugin
export default {"paginate":"CoursePauseRequestPagination_paginate__yIAXw"};